export const SHOP_LAST_PAGE_COOKIE = 'shop_last_page';

export const PERPAY_REFERRAL_COOKIE = 'perpay-referral';

export const PERPAY_UTM_COOKIE = 'perpay_utms';
